import './about.css'
import { motion } from 'framer-motion'

const reveal = {
  hidden: { opacity: 0, y: 28 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
}

export default function AboutCenter({ Title, Subtitle, children }) {
  return (
    <motion.section
      className="about about-center"
      style={{ backgroundColor: 'rgba(196,228,248,0.29)' }}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.25 }}
      variants={reveal}
    >
      <div className="about-container about-center-container">
        <motion.div className="about-text" variants={reveal}>
          <h2>{Title}</h2>
          <h3>{Subtitle}</h3>
          {children}
        </motion.div>
      </div>
    </motion.section>
  )
}